import { Link } from "react-router-dom";
import { latestArticles } from "@/mocks/homeData";

export default function LatestArticlesSection() {
  const formatViews = (n: number) => {
    if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
    return n.toString();
  };

  const categoryColorMap: Record<string, string> = {
    "网红黑料": "bg-primary-100/80 text-primary-700",
    "明星八卦": "bg-accent-100/80 text-accent-900",
    "社会奇闻": "bg-secondary-100/80 text-secondary-900",
  };

  const firstArticle = latestArticles[0];
  const restArticles = latestArticles.slice(1);

  return (
    <section className="relative py-16 md:py-24 px-4 md:px-8" aria-label="最新爆料">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <span className="text-xs text-foreground-500 font-medium tracking-wider uppercase mb-3 block">
              每日精选
            </span>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading text-foreground-50">
              最新爆料
            </h2>
          </div>
          <Link
            to="/category/wanghong-heiliao"
            className="flex items-center gap-1.5 text-sm text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer whitespace-nowrap"
          >
            <span>浏览全部</span>
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
          {firstArticle && (
            <div className="lg:col-span-7">
              <Link
                to={`/article/${firstArticle.id}`}
                className="group block cursor-pointer"
              >
                <div className="relative rounded-2xl overflow-hidden aspect-[16/10]">
                  <img
                    src={firstArticle.image}
                    alt={firstArticle.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    title={`911爆料 - ${firstArticle.title}`}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-100/90 via-background-100/20 to-transparent"></div>
                  <div className="absolute top-4 left-4 flex gap-2">
                    <span
                      className={`px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
                        categoryColorMap[firstArticle.category] || "bg-secondary-100/80 text-secondary-900"
                      }`}
                    >
                      {firstArticle.category}
                    </span>
                  </div>
                  <div className="absolute bottom-5 left-5 right-5">
                    <h3 className="text-xl md:text-2xl font-medium text-foreground-50 leading-snug mb-2 group-hover:text-primary-400 transition-colors">
                      {firstArticle.title}
                    </h3>
                    <p className="text-sm text-foreground-400 leading-relaxed line-clamp-2 mb-3">
                      {firstArticle.excerpt}
                    </p>
                    <div className="flex items-center gap-3 text-xs text-foreground-500">
                      <span>{firstArticle.date}</span>
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line w-3.5 h-3.5 flex items-center justify-center"></i>
                        {formatViews(firstArticle.views)}
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          )}

          <div className="lg:col-span-5 flex flex-col gap-4">
            {restArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group flex gap-4 cursor-pointer bg-background-100/50 rounded-xl p-3 border border-background-300/20 hover:border-background-300/50 transition-colors"
              >
                <div className="w-24 h-24 md:w-28 md:h-28 flex-shrink-0 rounded-lg overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    title={`911爆料 - ${article.title}`}
                  />
                </div>
                <div className="flex-1 min-w-0 flex flex-col justify-center">
                  <span
                    className={`self-start px-2 py-0.5 rounded-full text-[10px] font-medium whitespace-nowrap mb-2 ${
                      categoryColorMap[article.category] || "bg-secondary-100/80 text-secondary-900"
                    }`}
                  >
                    {article.category}
                  </span>
                  <h4 className="text-sm text-foreground-200 font-medium leading-snug line-clamp-2 group-hover:text-primary-400 transition-colors mb-2">
                    {article.title}
                  </h4>
                  <div className="flex items-center gap-3 text-xs text-foreground-600">
                    <span>{article.date}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
                      {formatViews(article.views)}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}